import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { misc, text } from '../assets/styles/utility';
import { generateGradient } from '../assets/styles/utility/gradient';
import Container from './Container';
import { jsx as ___EmotionJSX } from "@emotion/react";

const StylesSubnavVariables = theme => ({
  height: theme.height.large
});

export const SubnavMenuItemStyles = theme => [text.heading(theme), {
  color: theme.fontColor.muted,
  display: 'block',
  height: StylesSubnavVariables(theme).height,
  lineHeight: StylesSubnavVariables(theme).height + "px",
  position: 'relative',
  fontSize: theme.fontSize.small,
  letterSpacing: theme.letterSpacing.small,
  textTransform: 'uppercase',
  transition: "color " + theme.timing.base + " " + theme.transition.base,
  '&:hover, &:focus': {
    color: theme.fontColor.base
  },
  '&[disabled]': {
    opacity: theme.opacity.base,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },
  '&.is-active': {
    color: theme.fontColor.base,
    '&::before': {
      content: "''",
      position: 'absolute',
      left: 0,
      width: '100%',
      bottom: 0,
      height: 3,
      background: theme.color.primary.base
    }
  }
}];

const Subnav = _ref => {
  let {
    children,
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: /*#__PURE__*/_css({
      background: generateGradient({
        start: theme.color.panel.light,
        stop: theme.color.panel.base,
        position: 'to bottom'
      }),
      borderBottom: theme.border.large
    }, process.env.NODE_ENV === "production" ? "" : ";label:Subnav;"),
    className: clsx('CK__Subnav', className)
  }, rest), ___EmotionJSX(Container, {
    css: [misc.overflow, {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: StylesSubnavVariables(theme).height
    }, process.env.NODE_ENV === "production" ? "" : ";label:Subnav;"]
  }, children));
};

export default Subnav;